import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

const CHECKOUT_CART_QUERY_KEY_SUFFIX = "CHECKOUT_CART_QUERY_KEY";
const CHECKOUT_SUMMARY_QUERY_KEY_SUFFIX = "CHECKOUT_SUMMARY_QUERY_KEY";

/**
 * This hook provides a function to clear  checkout data from the cache.
 * It clears both the cart and checkout summary queries. Merely invalidating the queries is not enough
 * since it will remain in the cache as stale data, meaning the Checkout page won't refetch it on mount.
 */
export const useInvalidateCheckoutData = () => {
  const queryClient = useQueryClient();

  return useCallback(() => {
    // Remove all cart queries with the suffix from the cache
    queryClient.removeQueries({
      predicate: (query) => {
        return query.queryKey.includes(CHECKOUT_CART_QUERY_KEY_SUFFIX);
      },
    });

    // Remove all checkout summary queries with the suffix
    queryClient.removeQueries({
      predicate: (query) => {
        return query.queryKey.includes(CHECKOUT_SUMMARY_QUERY_KEY_SUFFIX);
      },
    });
  }, [queryClient]);
};
